var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-menu",
        {
          attrs: {
            "content-class": "menu elevation-24",
            "close-on-content-click": false,
            fixed: "",
            left: "",
            "nudge-right": "8"
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        staticClass: "mr-2",
                        attrs: {
                          flat: "",
                          icon: "",
                          title: "Jobs suivis",
                          disabled: Object.keys(_vm.jrs).length === 0,
                          color: "yellow accent-3"
                        }
                      },
                      on
                    ),
                    [
                      Object.keys(_vm.jrs).length || _vm.pulsing
                        ? _c("v-icon", { class: { pulse: _vm.pulsing } }, [
                            _vm._v("\n\t\t\t\t\tstar\n\t\t\t\t")
                          ])
                        : _c("v-icon", { class: { pulse: _vm.pulsing } }, [
                            _vm._v("\n\t\t\t\t\tstar_outline\n\t\t\t\t")
                          ])
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.menu,
            callback: function($$v) {
              _vm.menu = $$v
            },
            expression: "menu"
          }
        },
        [
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "background darken-2" },
            [
              _c(
                "v-card-title",
                { staticClass: "subheading py-1 pr-1" },
                [
                  _vm._v("\n\t\t\t\tMes jobs suivis\n\t\t\t\t"),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "", small: "" },
                      on: {
                        click: function($event) {
                          _vm.menu = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pa-0 background darken-2 menu-content" },
                [
                  _c(
                    "table",
                    { attrs: { width: "100%" } },
                    _vm._l(_vm.jrs, function(jr, id) {
                      return _c("tbody", { key: id, attrs: { jr: jr } }, [
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: {
                                    flat: "",
                                    icon: "",
                                    color: "warning"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeJr(id)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("close")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "jr-infos" }, [
                              _vm._v(_vm._s(jr.label))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "caption jr-infos" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(jr.storage.title || "-") +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "caption jr-infos" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(jr.storage.label || "-") +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "div",
                                { class: _vm.$colors.setColorText(jr) },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(jr.get_status_display) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-progress-linear",
                                {
                                  staticClass: "my-1",
                                  attrs: {
                                    value: jr.progress,
                                    height: "20",
                                    color: _vm.$colors.setColor(jr)[0]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(Math.floor(jr.progress)) +
                                      " %\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: {
                                    flat: "",
                                    icon: "",
                                    to: {
                                      name: "Maestro job",
                                      params: { jr_id: jr.id }
                                    },
                                    target: "_blank"
                                  }
                                },
                                [_c("v-icon", [_vm._v("open_in_new")])],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-none",
                      attrs: {
                        flat: "",
                        color: "warning",
                        disabled: Object.keys(_vm.jrs).length === 0
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeDoneJrs()
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("delete_sweep")
                      ]),
                      _vm._v("\n\t\t\t\t\tPurger les jobs terminés\n\t\t\t\t")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1bb16ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1bb16ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/globals/followed_jrs.vue
// module id = null
// module chunks = 